import {useState} from 'react'
import {getUser} from '../services'
import {UserModel, SelectModel} from '../model'

const useUserListService = () => {
  const [loading, setLoading] = useState(false)
  const [userList, setUserList] = useState<SelectModel[]>([])

  const getUserData = async (userParams: UserModel) => {
    setLoading(true)
    try {
      const response = await getUserService(userParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching user data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getUserService = async (userParams: UserModel) => {
    let obj: UserModel = {
      isCombo: true,
      ...userParams,
    }
    return await getUser(obj, 1)
  }

  const mapUser = (data: any[]) => {
    return data.map((item) => ({
      value: item.id,
      label: `${item.nombres || ''} ${item.apellidos || ''} ${item.numeroDocumento || ''}`,
      ...item,
    }))
  }

  const updateUserList = (mappedSites: {value: string; label: string}[]) => {
    setUserList(mappedSites)
  }

  const getUserList = async (userParams: UserModel = {}) => {
    try {
      const data = await getUserData(userParams)
      const mappedSites = mapUser(data)
      updateUserList(mappedSites)
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  const handleClear = () => {
    setUserList([])
  }

  return {
    loading,
    userList,
    getUserList,
    getUserData,
    handleClear,
  }
}

export default useUserListService
